const _login_user_ = ShopifyAnalytics.meta.page.customerId;
let _btn_add_my_favorites = document.querySelectorAll(".add_f_btn");
_btn_add_my_favorites.forEach(function (currentBtn) {
    currentBtn.addEventListener("click", (handleEvent) => {
        if (_login_user_) {
            console.log(currentBtn.getAttribute("data-id"));
            const _prod_handle = currentBtn
                .getAttribute("data-url")
                .replace("/products/", "");
            console.log(_prod_handle);
            update_favorites(_prod_handle);
            // currentBtn.classList.toggle('save');
            //update all this product fav
            update_others_this_product_btn(_prod_handle);
        } else {
            window.location.href = "/account/login";
        }
    });
});

const update_others_this_product_btn = (_prod_handle_org) => {
    _btn_add_my_favorites.forEach(function (currentBtn) {
        const _prod_handle = currentBtn
            .getAttribute("data-url")
            .replace("/products/", "");
        if (_prod_handle_org == _prod_handle) {
            currentBtn.classList.toggle('save');
        }
    })
}

const update_favorites = async (prod_handle) => {
    const payload = {};
    payload.customer_id = _login_user_.toString();
    payload.prod_handle = prod_handle;
    const url = "https://easterncurator-app.vercel.app/api/favorites";
    fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
    })
        .then((response) => response.json())
        .then(async (response) => {
            console.log(response);
        });
};

const get_customer_favorites = async () => {
    if (_login_user_) {
        const url = "https://easterncurator-app.vercel.app/api/favorites?customer_id=" + _login_user_.toString();
        fetch(url)
            .then((response) => response.json())
            .then(async (response) => {
                console.log(response.list);
                set_my_favprites(response.list);
            });
    }
}

const set_my_favprites = (list) => {
    _btn_add_my_favorites.forEach(function (currentBtn) {
        const _this_prod_handle = currentBtn.getAttribute("data-url").replace("/products/", "");;
        console.log(_this_prod_handle)
        for (const item of list) {
            if (item.handle == _this_prod_handle) {
                currentBtn.classList.add("save");
                break
            }
        }
    });
}

const resetFavorites = () => {
    _btn_add_my_favorites = document.querySelectorAll(".add_f_btn");
    _btn_add_my_favorites.forEach(function (currentBtn) {
        currentBtn.addEventListener("click", (handleEvent) => {
            if (_login_user_) {
                console.log(currentBtn.getAttribute("data-id"));
                const _prod_handle = currentBtn
                    .getAttribute("data-url")
                    .replace("/products/", "");
                console.log(_prod_handle);
                update_favorites(_prod_handle);
                currentBtn.classList.toggle('save');
            } else {
                window.location.href = "/account/login";
            }
        });
    });
}

get_customer_favorites();